<label class="switch" [ngClass]="size" [ngStyle]="{ 'margin-right': disableMargin ? '0px' : '' }">
  <input type="checkbox" [disabled]="disable" (change)="toggleCheckBox($event)" value="{{ CheckBoxValue }}" [checked]="CheckBoxValue" name="vatEnabledToggle" />
  <span class="slider round" [ngClass]="size">
    <img *ngIf="CheckBoxValue && showIcons" class="toggle-image" [src]="iconService.Icon.check" />
    <img *ngIf="!CheckBoxValue && showIcons" class="toggle-image" [src]="iconService.Icon.cross" />
  </span>
</label>
